<ng-template
  #changeField
  let-label="label"
  let-change="change"
  let-fullWidth="fullWidth">
  @if (change) {
    <div
      class="history-entry__change"
      [class.history-entry__change--full-width]="fullWidth">
      <span class="history-entry__change-label">{{ label }}</span>
      @if (fullWidth && change.previous !== undefined) {
        <div class="history-entry__change-diff">
          <span class="history-entry__change-side">{{ change.previous }}</span>
          <rds-icon
            class="history-entry__change-arrow"
            namespace="outlined"
            icon="arrow_right" />
          <span class="history-entry__change-side">{{ change.current }}</span>
        </div>
      } @else {
        <span class="history-entry__change-value">
          @if (change.previous !== undefined) {
            {{ change.previous }} → {{ change.current }}
          } @else {
            {{ change.current }}
          }
        </span>
      }
    </div>
  }
</ng-template>

@if (isLoading()) {
  <div class="loader">
    <rds-progress-spinner></rds-progress-spinner>
  </div>
}

<div class="history-container">
  @for (entry of viewModel(); track entry.revisionNumber) {
    <div class="history-entry">
      <rds-avatar size="l" [disableInteractions]="true">
        <rds-icon rds-avatar-icon namespace="outlined" icon="user" />
      </rds-avatar>

      <div class="history-entry__content">
        <div class="history-entry__header">
          <span class="ui-body-m-bold">{{ entry.updatedBy || 'System' }}</span>
          @if (entry.updateDate) {
            <span class="ui-body-s c-600-grey-2">{{
              entry.updateDate | date: 'd MMMM y, HH:mm'
            }}</span>
          }
        </div>

        <div class="history-entry__title">
          <em>{{ entry.header }}</em>
        </div>

        <div class="history-entry__changes">
          <ng-container
            *ngTemplateOutlet="
              changeField;
              context: { label: 'Room Status', change: entry.active }
            " />
          <ng-container
            *ngTemplateOutlet="
              changeField;
              context: {
                label: 'Automatic Approval',
                change: entry.automaticApproval,
              }
            " />
          <ng-container
            *ngTemplateOutlet="
              changeField;
              context: { label: 'Freeze Days', change: entry.freezeDays }
            " />
          <ng-container
            *ngTemplateOutlet="
              changeField;
              context: {
                label: 'Security and Compliance Service',
                change: entry.generalQuestionsEnabled,
              }
            " />
          <ng-container
            *ngTemplateOutlet="
              changeField;
              context: {
                label: 'Default Layout',
                change: entry.defaultLayoutId,
              }
            " />
          <ng-container
            *ngTemplateOutlet="
              changeField;
              context: { label: 'Services', change: entry.services }
            " />
          <ng-container
            *ngTemplateOutlet="
              changeField;
              context: {
                label: 'Room Blocking Time',
                change: entry.blockingTimes,
              }
            " />
          <ng-container
            *ngTemplateOutlet="
              changeField;
              context: {
                label: 'Meeting Duration Range',
                change: entry.durationRange,
              }
            " />
          <ng-container
            *ngTemplateOutlet="
              changeField;
              context: {
                label: 'Description',
                change: entry.description,
                fullWidth: true,
              }
            " />
        </div>
      </div>
    </div>
  } @empty {
    <rds-empty-state alignment="center">
      <rds-empty-state-title
        >No modifications have been made since the room was
        created.</rds-empty-state-title
      >
    </rds-empty-state>
  }
</div>
